import { TimerAlertIcon } from './TimerAlertIcon';

/**
 * author: Colton Wiscombe
 * id 7A645EAB-94F5-49FA-8A73-D9D1045D3B34
 * name timer-alert
 * version: 6.8.96
 * url https://raw.githubusercontent.com/Templarian/MaterialDesign/master/svg/timer-alert.svg
 * tags
 * - Date / Time 
 * - Alert / Error 
 */
export const StopwatchAlertIcon = TimerAlertIcon;
export default StopwatchAlertIcon